import React from 'react';
import { PaymentMethodCard as PaymentMethod } from '@thd-olt-component-react/payment-method-card';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
export var PaymentMethodCard = function () { return (React.createElement(ErrorBoundary, { name: "payment-card" },
    React.createElement(PaymentMethod, null))); };
